import type { FC } from "react";
import { RetirementDropRow } from "web_myplann/Inspiration/Retirement/Components/RetirementDropRow";
import type { RetirementDrop } from "web_myplann/Inspiration/Retirement/Types/RetirementTypes";

type Props = {
	drops: RetirementDrop[];
	onToggle: (id: string) => void;
	onRemove: (id: string) => void;
};

export const RetirementDropList: FC<Props> = ({
	drops,
	onToggle,
	onRemove,
}) => (
	<>
		{drops.map((drop) => (
			<RetirementDropRow
				key={drop.id}
				drop={drop}
				onToggle={() => onToggle(drop.id)}
				onRemove={() => onRemove(drop.id)}
			/>
		))}
	</>
);
